import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
export function resultCodeCheck(_x) {
  return _resultCodeCheck.apply(this, arguments);
}
function _resultCodeCheck() {
  _resultCodeCheck = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(res.result === 1)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", res);
          case 2:
            return _context.abrupt("return", Promise.reject(res));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resultCodeCheck.apply(this, arguments);
}